import { ReplaySubject } from 'rxjs';

import { Injectable } from '@angular/core';
import { NotificationSettings, NotificationToast, NotificationType } from '@core/services/notification/notification';
import { TranslationKey } from '@shared/translations/auto-generated/translation-key';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    public notification$: ReplaySubject<NotificationToast> = new ReplaySubject(1);

    /**
     * Creates a new notification toast and emits it to the notification$ observable
     * @param settings
     */
    public createNotification(settings: NotificationSettings = {}): void {
        const newNotification: NotificationToast = {
            id: new Date().valueOf(),
            initiateClose: false,
            type: 'error',
            translationHeadline: this.getDefaultHeadline(settings?.type ?? 'error'),
            fadeTime: 5000,
            showHeadline: true,
            ...settings
        };
        this.notification$.next(newNotification);
    }

    private getDefaultHeadline(type: NotificationType): TranslationKey {
        switch (type) {
            case 'success':
                return 'general.validation.success';
            case 'error':
                return 'general.validation.generic';
            case 'warning':
                return 'general.validation.warning';
            case 'info':
                return 'general.validation.info';
        }
    }
}
